import type {
  CleaningAssigneeResponse,
  CleaningAssigneeRole,
  CleaningTaskResponse,
} from '@/shared/api';

const ROLE_LABEL: Record<CleaningAssigneeRole, string> = {
  Housekeeping: 'Reinigung',
  HousekeepingManager: 'Reinigungsleitung',
  Staff: 'Team',
  WorkspaceAdmin: 'Verwaltung',
};

export interface AssigneeOption {
  userId: string;
  label: string;
  /**
   * Die aktuelle Zuweisung, die der Server so nicht mehr annehmen würde — der Zugriff auf das
   * Apartment ist weg oder das Konto ist deaktiviert. Bleibt sichtbar, weil sonst ein leeres
   * Auswahlfeld über einer besetzten Aufgabe stünde; auswählbar ist sie nicht.
   */
  stale: boolean;
}

/**
 * Auswahl für die Zuweisung: die vom Server als zuweisbar gemeldeten Personen, plus — falls
 * nötig — die bestehende Zuweisung als nicht wählbarer Eintrag.
 */
export function buildAssigneeOptions(
  assignable: readonly CleaningAssigneeResponse[],
  task: Pick<CleaningTaskResponse, 'assignedToUserId' | 'assignedToUserName'>,
): AssigneeOption[] {
  const options = assignable.map((a) => ({
    userId: a.userId,
    label: `${a.displayName} · ${ROLE_LABEL[a.role] ?? a.role}`,
    stale: false,
  }));
  const current = task.assignedToUserId;
  if (current && !assignable.some((a) => a.userId === current)) {
    options.unshift({
      userId: current,
      label: `${task.assignedToUserName ?? `${current.slice(0, 8)}…`} · kein Zugriff mehr`,
      stale: true,
    });
  }
  return options;
}
